import firebase from 'firebase'
import 'firebase/firestore'

require('firebase/auth')
require('firebase/storage')
require('firebase/firestore')
require('firebase/messaging')
require('firebase/functions')

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyDM2uO31iHLo0ZsIqpdnOiFq9O42O2okOc',
  authDomain: 'freshstart-f84dc.firebaseapp.com',
  databaseURL: 'https://freshstart-f84dc.firebaseio.com',
  projectId: 'freshstart-f84dc',
  storageBucket: 'freshstart-f84dc.appspot.com',
  messagingSenderId: '24743777605'
}
firebase.initializeApp(config)
// firebase utils
const auth = firebase.auth()
const db = firebase.firestore()
const storage = firebase.storage()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
  timestampsInSnapshots: true
}
db.settings(settings)

export {
  db,
  auth,
  storage,
  currentUser
}



// WEBPACK FOOTER //
// ./src/services/firebase.js